module.exports = __webpack_public_path__ + "static/media/paid-dark.833c2abd.svg";